import { animationPresets, presetsByCategory } from "./presets";

import type { ElementAnimation } from "./types";

/** Preset applied to a freshly added clip — the first entrance preset, or any
 * registered preset as a fallback. Kept as a function because presets register
 * at import time. */
export const defaultClipPresetId = (): string =>
  presetsByCategory("entrance")[0]?.id ?? Object.keys(animationPresets)[0];

/** Builds a clip from a preset's defaults, with optional field overrides. */
export const makeClip = (
  presetId: string,
  overrides: Partial<ElementAnimation> = {},
): ElementAnimation => {
  const preset = animationPresets[presetId];
  return {
    // added clips play in parallel with the previous one by default; the
    // ∥/→ badge in the bar lets the user sequence them after instead
    startMode: "with",
    preset: preset.id,
    ...preset.defaults,
    ...overrides,
    params: { ...preset.defaults.params, ...overrides.params },
  };
};
